import VideoFlat from '../../src/legacy/VideoFlat.tsx';
export default VideoFlat;
